import { db } from "firebase.js";
import { collection, getDocs, doc, getDoc, updateDoc } from "firebase/firestore";

// 🔹 Fetch all locations
export const getAllLocations = async () => {
  const snapshot = await getDocs(collection(db, "locations"));

  console.log(`Firestore read count: ${snapshot.docs.length}`);
  
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

export const fetchLocationById = async (locationId) => {
  const docRef = doc(db, "locations", locationId);
  const snapshot = await getDoc(docRef);

  if (!snapshot.exists()) return null;

  return {
    id: snapshot.id,
    ...snapshot.data(),
  };
};

export const getDisplayRanking = async (locationId) => {
  const ref = doc(db, "locations", locationId);
  const snapshot = await getDoc(ref);
  if (!snapshot.exists()) throw new Error("Location not found");
  return snapshot.data().displayRanking || false;
};

export const updateDisplayRanking = async (locationId, value) => {
  const ref = doc(db, "locations", locationId);
  await updateDoc(ref, { displayRanking: value });
};
